import { useEffect, useState } from "react";
import { Home, Utensils } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Reveal, MaskLinesInView } from "./motion";
import BookingWidget from "./BookingWidget";
import GastroBookingWidget from "./GastroBookingWidget";

export default function Booking() {
  const [tab, setTab] = useState("alojamento");

  useEffect(() => {
    const handler = (e) => {
      if (e.detail === "alojamento" || e.detail === "gastronomia") setTab(e.detail);
    };
    window.addEventListener("cm:booking-tab", handler);
    return () => window.removeEventListener("cm:booking-tab", handler);
  }, []);

  return (
    <section id="reservar" data-testid="booking-section" className="relative py-28 lg:py-40 bg-[#EFEBE0]">
      <div className="mx-auto max-w-[1200px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-end mb-12 lg:mb-14">
          <div className="lg:col-span-8">
            <Reveal>
              <div className="flex items-center gap-4 mb-8">
                <span className="h-px w-14 bg-forest/40" />
                <p className="overline">Reservar Online</p>
              </div>
            </Reveal>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-[4.2rem] leading-[1.02] tracking-tight text-forest font-light">
              <MaskLinesInView lines={["Escolha o que procura.", <span key="i" className="italic">Reserve num instante.</span>]} />
            </h2>
          </div>
          <Reveal delay={0.1} className="lg:col-span-4">
            <p className="text-muted-foreground leading-relaxed">
              Dois sistemas independentes: estadias na casa e eventos privados. Confirmação imediata por email.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.05}>
          <Tabs value={tab} onValueChange={setTab} className="w-full" data-testid="booking-tabs">
            <TabsList className="mb-8 h-auto bg-transparent p-0 gap-3 flex flex-wrap justify-start">
              <TabsTrigger
                value="alojamento"
                data-testid="tab-alojamento"
                className="group data-[state=active]:bg-forest data-[state=active]:text-cream data-[state=active]:shadow-none bg-white border border-border rounded-full h-12 px-6 text-[0.78rem] tracking-[0.16em] uppercase font-medium text-forest inline-flex items-center gap-2 transition-colors"
              >
                <Home size={16} strokeWidth={1.5} /> Alojamento
              </TabsTrigger>
              <TabsTrigger
                value="gastronomia"
                data-testid="tab-gastronomia"
                className="group data-[state=active]:bg-terracotta data-[state=active]:text-cream data-[state=active]:shadow-none bg-white border border-border rounded-full h-12 px-6 text-[0.78rem] tracking-[0.16em] uppercase font-medium text-forest inline-flex items-center gap-2 transition-colors"
              >
                <Utensils size={16} strokeWidth={1.5} /> Eventos Privados
              </TabsTrigger>
            </TabsList>

            <TabsContent value="alojamento" className="mt-0">
              <div className="mb-5 flex items-center gap-3 text-forest">
                <Home size={18} strokeWidth={1.5} />
                <p className="text-sm text-muted-foreground">Reserva por noites — as datas escolhidas ficam indisponíveis para novas reservas de alojamento.</p>
              </div>
              <BookingWidget />
            </TabsContent>

            <TabsContent value="gastronomia" className="mt-0">
              <div className="mb-5 flex items-center gap-3 text-terracotta">
                <Utensils size={18} strokeWidth={1.5} />
                <p className="text-sm text-muted-foreground">Pedido de reserva para eventos privados — respondemos com uma proposta personalizada. Independente do alojamento.</p>
              </div>
              <GastroBookingWidget />
            </TabsContent>
          </Tabs>
        </Reveal>
      </div>
    </section>
  );
}
